import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntityEnvironment_Interface } from 'src/app/Interface/DataEntity/DataEntityEnvironment_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntityEnvironmentService {

  constructor(private http:HttpClient) { }

  GetRecord(id:number):Observable<Array<DataEntityEnvironment_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DataentityEnvironment?id="+id).pipe(
      map(data=>{
        return data as Array<DataEntityEnvironment_Interface>
      })
    )
  }



  Submit(model:Array<DataEntityEnvironment_Interface>,id:number):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var model_temp = []
    for (let item of model)
    {
      model_temp.push({
        environment_id : item.id,
        device_id : id,
        detal : Number(item.detal),
        max_rage : Number(item.max_rage),
        min_range : Number(item.min_range),
      })
    }

    var body={
      Model:model_temp,
      id:id,
    }

    return this.http.post(environment.BaseUrl + "Daro/DataentityEnvironment/PostEnvironment",body,{headers}).pipe(
      map(data=>{
        return data as any
      })
    )

  }


}
